import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Alert, FormLabel, Grid, Typography } from "@mui/material"
import { AcademicLevel, Campus, ConsentementMultiple, RequiredFields, Submit } from "components"
import { Email, InputCheckbox, InputText, PhoneNumber } from "components/fields"
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { consent, defaultValues, specialities } from "services"
import { useEffect } from "react"
import MentionsLegales from "components/MentionsLegales"
import { coalesceProductId, getProductIdFromLocation, resolveCampaignIdFromProductId } from "services/landingPageProductId"

const Form = () => {
  const isFormSent =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("form_sent") === "true"

  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('ISG-DOC-LP-PSUP')
  const { submission } = useSubmission()
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...consent,
      ...specialities,
      lead: {
        ...defaultValues
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, setValue, watch } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campus = lead.Campus__c
    const defaultDataLead = {
      Division__c: 'ISG France',
      IONISSchool__c: 'ISG',
      LastForm__c: 'Demande de doc PSUP',
      LeadSource: 'Internet: Demande de doc',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      const productId = coalesceProductId(lead?.ProductId, getProductIdFromLocation())
      const campaignId = await resolveCampaignIdFromProductId({ salesforce, productId })

      await submission({
        formId: 'DOC',
        campaignId,
        lead: finalLead,
        campaignStatus: 'Requested',
        utmCookieName: '_ionis_user_data' // optionnel
      })
      document.location.href=`${url}&ville=${campus}`
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const campus = watch('lead.Campus__c')
  // useEffect
  useEffect(() => {
    setValue('lead.BMI__c', false)
    setValue('lead.PGE__c', false)
    if (campus !== '' && campus !== 'Paris') {
      setValue('lead.BMI__c', true)
    }
  }, [campus, setValue])


  useSalesforce('ISG')

  return (
    <FormProvider {...methods}>
      {isFormSent ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Alert severity="success">
              <Typography variant="h6" gutterBottom>
                Merci !
              </Typography>
              <Typography>
                Votre demande a bien été envoyée.
              </Typography>
            </Alert>
          </Grid>
        </Grid>
      ) : (
        <>
          <DevTool control={control} />
          <Grid container spacing={2}>
            <Grid item sm={6} xs={12}>
              <InputText control={control} label="Prénom" name="lead.FirstName" required />
            </Grid>
            <Grid item sm={6} xs={12}>
              <InputText control={control} label="Nom" name="lead.LastName" required />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Email control={control} label="Adresse e-mail" name="lead.Email" required />
            </Grid>
            <Grid item sm={6} xs={12}>
              <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
            </Grid>
            <AcademicLevel section={false} />
            <Grid item sm={6} xs={12}>
              <Campus label="Campus souhaité" />
            </Grid>
              {(campus === 'Paris') && (
                <Grid item sm={12} xs={12}>
                  <FormLabel component="legend">Vous êtes intéressé par :*</FormLabel>
                  <InputCheckbox control={control} name="lead.PGE__c" label="Programme Grande École en 5 ans" /><br />
                  <InputCheckbox control={control} name="lead.BMI__c" label="Bachelor en Management International" /><br />
                </Grid>
              )}
            <ConsentementMultiple />
            <RequiredFields />
            <Submit onSubmit={onSubmit} />
            <MentionsLegales form="Documentation" school="ISG France" />
          </Grid>
        </>
      )}
    </FormProvider>
  )
}

export default Form
